import { useTheme } from '@mui/material';

export const useSxStyles = () => {
  const theme = useTheme();

  return {
    root: {
      display: 'flex',
      gap: theme.spacing(2),
      padding: '8px 0px',
    },
    section: {
      width: '365px',
    },
  };
};
